<!--
  ~ Copyright (C) 2019 - present by OpenGamma Inc. and the OpenGamma group of companies
  ~
  ~ Please see distribution for license.
  -->

<div class="og-content og-content--{{ pageLayout$ | async }}">
  <ng-content></ng-content>
</div>
